/**
 * Router utility functions
 */

/**
 * Check if route requires authentication
 */
export const requiresAuth = (route) => {
  return route.meta?.requiresAuth === true
}

/**
 * Check if route requires specific roles
 */
export const requiresRoles = (route) => {
  return route.meta?.roles || []
}

/**
 * Get route title
 */
export const getRouteTitle = (route) => {
  return route.meta?.title || 'MySettle'
}

/**
 * Check if user can access route based on roles
 */
export const canAccessRoute = (route, userRoles) => {
  const requiredRoles = requiresRoles(route)
  if (requiredRoles.length === 0) return true
  
  return requiredRoles.some(role => userRoles.includes(role))
}

/**
 * Get login URL based on role or route context
 * @param {string} role - User role (optional)
 * @param {object} route - Route object (optional)
 * @returns {string} Login route name
 */
export const getLoginRoute = (role = null, route = null) => {
  // If role is provided, use it
  if (role) {
    if (['hq-admin', 'hq-dispatcher'].includes(role)) {
      return 'admin-login'
    }
    if (['staff', 'branch-manager'].includes(role)) {
      return 'staff-login'
    }
    return 'login' // Default to customer login
  }

  // If route has role requirements, determine from route
  if (route?.meta?.roles) {
    const roles = route.meta.roles
    if (roles.some(r => ['hq-admin', 'hq-dispatcher'].includes(r))) {
      return 'admin-login'
    }
    if (roles.some(r => ['staff', 'branch-manager'].includes(r))) {
      return 'staff-login'
    }
  }

  // Default to customer login
  return 'login'
}

